import { baseUrl } from "../../utils/constants";
import { client } from "../client";
import { GETZONEGRID, GETZONELIST, GETZONESOFRIO, ZONE } from "../endpoints";

export const createZone = async ({
  rioId,
  zoneName,
}: {
  rioId: number;
  zoneName: string;
}) => {
  const response = await client.post(`${baseUrl}${ZONE}`, {
    zoneName,
    rioId,
  });
  return response;
};

export const updateZone = async ({
  rioId,
  zoneId,
  zoneName,
}: {
  rioId: number;
  zoneId: number;
  zoneName: string;
}) => {
  const response = await client.put(`${baseUrl}${ZONE}`, {
    zoneId: zoneId,
    zoneName: zoneName,
    rioId: rioId,
  });
  return response;
};

export const getAllZone = async () => {
  const response = await client.get(`${baseUrl}${GETZONELIST}`);
  return response;
};

export const getZoneById = async (zoneId: number) => {
  const response = await client.get(`${baseUrl}${ZONE}?zoneId=${zoneId}`);
  return response;
};

export const getZoneGrid = async ({
  page,
  size,
  searchQuery,
}: {
  page: number;
  size: number;
  searchQuery: string;
}) => {
  const response = await client.get(`${baseUrl}${GETZONEGRID}`, {
    params: {
      page,
      size,
      searchQuery,
    },
  });
  return response;
};

export const removeZoneFromUser = async (zoneId: number) => {
  const response = await client.delete(`${baseUrl}${ZONE}`, {
    data: {
      zoneId: zoneId,
    },
  });
  return response;
};

export const getZonesByRIOId = async (rioId: number) => {
  const response = await client.get(
    `${baseUrl}${GETZONESOFRIO}?rioId=${rioId}`
  );
  return response;
};
